import Currency from 'components/Currency'
import I18n from 'components/I18n'
import ComponentText from 'components/Text'
import { selectors } from 'data'
import { ApiCurrency } from 'data/Currencies/types'
import messages from 'lang'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import styled from 'styled-components'

const Warning = styled(ComponentText)`
  display: flex;
  font-style: italic;
  margin-bottom: 0.5rem;
`

const Message = styled.div`
  padding-top: 0.25rem;
`

const Text = styled(ComponentText)`
  white-space: break-spaces;
`

const Title = ({ currency }) => {
  switch (currency) {
    case 'XLM':
      return <I18n data={messages.deposit_xlm_memo} currency={<Currency code={currency} />} />
    case 'XRP':
      return <I18n data={messages.deposit_xrp_tag} currency={<Currency code={currency} />} />
    default:
      return <I18n data={messages.important} />
  }
}

type ContentProps = {
  currency: string
  currencyData?: ApiCurrency
}
const Content = ({ currency, currencyData }: ContentProps) => {
  if (currency === 'DOT') {
    return (
      <>
        <Text color='dark200' size='sm'>
          <I18n data={messages.deposit_advice} value={<Currency code='DOT' />} />
        </Text>
        <Text color='dark200' size='sm'>
          &nbsp;
          <I18n data={messages.deposit_processing_times} />
        </Text>
        <Text color='dark200' size='sm'>
          &nbsp;
          <I18n data={messages.deposit_advice_dot_min} currency={<Currency code='DOT' />} />
        </Text>
      </>
    )
  }

  if (currency === 'CLOUT') {
    return (
      <Text color='dark200' size='sm'>
        <I18n data={messages.deposit_clout_memo_content} currency={<Currency code='CLOUT' />} />
      </Text>
    )
  }

  if (currency === 'XLM') {
    return (
      <Text color='dark200' size='sm'>
        <I18n data={messages.deposit_xlm_memo_content} currency={<Currency code='XLM' />} />
      </Text>
    )
  }

  if (currency === 'XRP') {
    return (
      <Text color='dark200' size='sm'>
        <I18n data={messages.deposit_xrp_tag_content} currency={<Currency code='XRP' />} />
      </Text>
    )
  }

  // Any ERC20 token
  if (currencyData?.type.parentChain === 'ETH') {
    return (
      <Text color='dark200' size='sm'>
        <I18n currency={<Currency code={currency} />} data={messages.deposit_advice_erc20_tokens} />
      </Text>
    )
  }

  return (
    <>
      <Text color='dark200' size='sm'>
        <I18n data={messages.deposit_advice} value={<Currency code={currency} />} />
      </Text>
      <Text color='dark200' size='sm'>
        &nbsp;
        <I18n data={messages.deposit_processing_times} />
      </Text>
    </>
  )
}

type Props = {
  currency: string
} & ConnectedProps<typeof connector>
const CurrencyDepositMessage = ({ currency, currencyData }: Props) => {
  return (
    <Message>
      <Warning color='orange500' weight={600}>
        <Title currency={currency} />
      </Warning>
      <Content currency={currency} currencyData={currencyData} />
    </Message>
  )
}

const mapStateToProps = (state, { currency }) => ({
  currencyData: selectors.currencies.getCurrency(state, currency)
})
const connector = connect(mapStateToProps)

export default connector(CurrencyDepositMessage)
